<div class="flex flex-col xl:flex-row lg:mt-0 lg:p-0">
    <div class="xl:ml-5 xl:w-[22%] pl-5 pr-14 lg:mt-5 lg:px-5 pb-5 xl:mr-6">
        <img src="assets/images/Logo main 1.png" class="h-6  mt-4 lg:h-8" alt="" />
        <div class="lg:text-[16px] text-[15.44px] border-b-[1px] pt-3 border-[#D8D8D8] pb-10 flex flex-col gap-2">

            <h1 class="text-[26.25px]"><b>{{userData.companyDetails.name}}</b></h1>
            <h4>{{userData.lastName}} {{userData.firstName}}</h4>
            <p class="font-light">
                <b class="font-semibold">Email:</b> {{userData.email}}
            </p>
            <p class="font-light">
                <b class="font-semibold">Phone:</b> {{userData.phone}}
            </p>
            <p class="font-light">
                <b class="font-semibold">Country:</b> {{userData.country.title}}
            </p>
            <p class="font-light">
                <b class="font-semibold">Created:</b> {{userData.created}}
            </p>
            <p class="font-light">
                <b class="font-semibold">Last modified:</b> {{userData.lastModified}}
            </p>
        </div>
        <div class="lg:text-[14.36px] font-light lg:pr-0 lg:pt-10 flex flex-col gap-3 mt-5 lg:mt-0">
            <p>
                7thaven Finance Inc. adheres to its AML/CFT policy and the
                applicable AML/CFT laws, necessitating the collection of fundamental
                details from both existing and new clients. Your cooperation in
                filling out this form is highly valued.
            </p>
            <p>
                *All information shared will be handled with utmost confidentiality.
                <br />**Where required, kindly furnish additional details or attach
                supporting documents.
            </p>
        </div>


        <!-- Buttons at the bottom -->
        <div class="button-wrapper d-flex" *ngIf="formComlete">
            <button type="button" data-bs-toggle="modal" data-bs-target="#modal-submit-kyc"
                class="btn btn-warning w-100">Submit KYC</button>
        </div>
    </div>
    <div class="bg-[#EAEEF5] xl:w-[78%] p-3 xl:h-fit text-[14px]">
        <div class="bg-white shadow-lg p-3 rounded">
            <div
                class="grid md:flex grid-rows-[2] border-b-[1px] font-light grid-cols-2 bg-[#EAEEF5] text-[#000000B2] md:justify-between p-2 text-[13px] md:items-center rounded">

                <!-- Company Details -->
                <p [class]="companyDetails ? 'bg-white font-semibold items-center flex p-2 rounded w-fit' : 'p-2 rounded w-fit'">
                    <a (click)="jump('companyDetails')" [routerLink]="">Company Details
                        <i *ngIf="companyDetailsComplete && companyDetailsForm.valid && !companyDetailsForm.pending && !userData.validation.companyDetails.status.rejected" 
                        class="fas fa-check-circle" style="color: green;" aria-hidden="true"></i>
                        <i *ngIf="!companyDetailsComplete || !companyDetailsForm.valid || companyDetailsForm.pending" 
                        class="fas fa-exclamation-circle" style="color: orange;" aria-hidden="true"></i>
                        <i *ngIf="userData.validation.companyDetails.status.rejected" 
                        class="fas fa-exclamation-circle" style="color: red;" [style.color]="'red'" aria-hidden="true"></i>
                    </a>
                </p>

                <!-- Principal Officers -->
                <p [class]="directorDetails ? 'bg-white font-semibold items-center flex p-2 rounded w-fit' : 'p-2 rounded w-fit'">
                    <a (click)="jump('directorDetails')">Principal Officers
                        <i *ngIf="directorDetailsComplete && !userData.validation.directorDetails.status.rejected" 
                        class="fas fa-check-circle" style="color: green;" aria-hidden="true"></i>
                        <i *ngIf="!directorDetailsComplete" 
                        class="fas fa-exclamation-circle" style="color: orange;" aria-hidden="true"></i>
                        <i *ngIf="userData.validation.directorDetails.status.rejected" 
                        class="fas fa-exclamation-circle" style="color: red;" [style.color]="'red'" aria-hidden="true"></i>
                    </a>
                </p>

                <!-- Contact Details -->
                <p [class]="contactPersonDetails ? 'bg-white font-semibold items-center flex p-2 rounded w-fit' : 'p-2 rounded w-fit'">
                    <a (click)="jump('contactPersonDetails')" [routerLink]="">Contact Details
                        <i *ngIf="contactPersonDetailsComplete && !userData.validation.contactPersonDetails.status.rejected" 
                        class="fas fa-check-circle" style="color: green;" aria-hidden="true"></i>
                        <i *ngIf="!contactPersonDetailsComplete" 
                        class="fas fa-exclamation-circle" style="color: orange;" aria-hidden="true"></i>
                        <i *ngIf="userData.validation.contactPersonDetails.status.rejected" 
                        class="fas fa-exclamation-circle" style="color: red;" [style.color]="'red'" aria-hidden="true"></i>
                    </a>
                </p>

                <!-- Ownerships and Account -->
                <p [class]="ownershipDetails ? 'bg-white font-semibold items-center flex p-2 rounded w-fit' : 'p-2 rounded w-fit'">
                    <a (click)="jump('ownershipDetails')" [routerLink]="">Ownerships and Account
                        <i *ngIf="!ownershipDetailsComplete" 
                        class="fas fa-exclamation-circle" style="color: orange;" aria-hidden="true"></i>
                        <i *ngIf="ownershipDetailsComplete && !anyRejected" 
                        class="fas fa-check-circle" style="color: green;" aria-hidden="true"></i>
                        <i *ngIf="anyRejected" 
                        class="fas fa-exclamation-circle" style="color: red;" [style.color]="'red'" aria-hidden="true"></i>
                    </a>
                </p>

                <!-- Transaction Details -->
                <p [class]="transactionDetails ? 'bg-white font-semibold items-center flex p-2 rounded w-fit' : 'p-2 rounded w-fit'">
                    <a (click)="jump('transactionDetails')" [routerLink]="">Transaction Details
                        <i *ngIf="transactionDetailsComplete && transactionDetailsForm.valid && !transactionDetailsForm.pending && !userData.validation.transactionDetails.status.rejected" 
                        class="fas fa-check-circle" style="color: green;" aria-hidden="true"></i>
                        <i *ngIf="!transactionDetailsComplete || !transactionDetailsForm.valid || transactionDetailsForm.pending" 
                        class="fas fa-exclamation-circle" style="color: orange;" aria-hidden="true"></i>
                        <i *ngIf="userData.validation.transactionDetails.status.rejected" 
                        class="fas fa-exclamation-circle" style="color: red;" [style.color]="'red'" aria-hidden="true"></i>
                    </a>
                </p>

                <!-- Compliance Details -->
                <p [class]="complianceDetails ? 'bg-white font-semibold items-center flex p-2 rounded w-fit' : 'p-2 rounded w-fit'">
                    <a (click)="jump('complianceDetails')" [routerLink]="">Compliance Details
                        <i *ngIf="complianceDetailsComplete && complianceDetailsForm.valid && !complianceDetailsForm.pending && !userData.validation.complianceDetails.status.rejected" 
                        class="fas fa-check-circle" style="color: green;" aria-hidden="true"></i>
                        <i *ngIf="!complianceDetailsComplete || !complianceDetailsForm.valid || complianceDetailsForm.pending" 
                        class="fas fa-exclamation-circle" style="color: orange;" aria-hidden="true"></i>
                        <i *ngIf="userData.validation.complianceDetails.status.rejected" 
                        class="fas fa-exclamation-circle" style="color: red;" [style.color]="'red'" aria-hidden="true"></i>
                    </a>
                </p>

                <!-- Upload Documents -->
                <p [class]="uploadFiles ? 'bg-white font-semibold items-center flex p-2 rounded w-fit' : 'p-2 rounded w-fit'">
                    <a (click)="jump('uploadFiles')" [routerLink]="">Upload Document
                        <i *ngIf="uploadFilesComplete && !userData.validation.uploadFiles.status.rejected" 
                        class="fas fa-check-circle" style="color: green;" aria-hidden="true"></i>
                        <i *ngIf="!uploadFilesComplete" 
                        class="fas fa-exclamation-circle" style="color: orange;" aria-hidden="true"></i>
                        <i *ngIf="userData.validation.uploadFiles.status.rejected" 
                        class="fas fa-exclamation-circle" style="color: red;" [style.color]="'red'" aria-hidden="true"></i>
                    </a>
                </p>
            </div>

            <form [formGroup]="companyDetailsForm" [hidden]="!companyDetails" class="space-y-4 border-t-[1px] border-[#D8D8D8] mt-4">

                <div class="alert alert-danger" role="alert" *ngIf="userData.validation.companyDetails.status.rejected">
                    <b>{{commentError}}</b>
                    
                    <hr *ngIf="userData.validation.companyDetails.comment.length > 0">
                    <div *ngFor="let commentRow of userData.validation.companyDetails.comment; index as i">
                        <span [innerHTML]="commentRow.comment"></span>
                        <br>
                    </div>
                </div>
                
                <!-- Form Group 1 -->
                <div class="row mb-3">
                    <label for="name" class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Name of the
                        Company</label>
                    <div class="col-sm-8">
                        <input type="text" required
                            [ngClass]="(name.invalid && (name.dirty || name.touched)) ? 'form-control is-invalid' : (name.valid)? 'form-control is-valid':'form-control'"
                            formControlName="name" id="name" placeholder="">
                        <div *ngIf="name.invalid && (name.dirty || name.touched)" class="invalid-feedback">
                            <div *ngIf="name.errors.required">Name of the Company: is required</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 2 -->
                <div class="row mb-3">
                    <label for="address" class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Registered Address</label>
                    <div class="col-sm-8">
                        <textarea required
                            [ngClass]="(address.invalid && (address.dirty || address.touched)) ? 'form-control is-invalid' : (address.valid)? 'form-control is-valid':'form-control'"
                            formControlName="address" id="address" placeholder="">
                        </textarea>
                        <div *ngIf="address.invalid && (address.dirty || address.touched)" class="invalid-feedback">
                            <div *ngIf="address.errors.required">Registered address is required</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="inputPassword"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Registration number</label>
                    <div class="col-sm-8">
                        <input type="text" required
                            [ngClass]="(reg_no.invalid && (reg_no.dirty || reg_no.touched)) ? 'form-control is-invalid' : (reg_no.valid)? 'form-control is-valid':'form-control'"
                            formControlName="reg_no" id="reg_no" placeholder="">
                        <div *ngIf="reg_no.invalid && (reg_no.dirty || reg_no.touched)" class="invalid-feedback">
                            <div *ngIf="reg_no.errors.required">Registration number is required</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="incoporation_date"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Date of Incorporation</label>
                    <div class="col-sm-8">
                        <input type="date" required
                            [ngClass]="(incoporation_date.invalid && (incoporation_date.dirty || incoporation_date.touched)) ? 'form-control is-invalid' : (incoporation_date.valid)? 'form-control is-valid':'form-control'"
                            formControlName="incoporation_date" id="incoporation_date" placeholder=""
                            [max]="today">
                        <div *ngIf="incoporation_date.invalid && (incoporation_date.dirty || incoporation_date.touched)" class="invalid-feedback">
                            <div *ngIf="incoporation_date.errors.required">Date of Incorporation is required</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="inputPassword" class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Trade
                        name (if different from legal name)</label>
                    <div class="col-sm-8">
                        <input type="text"
                            [ngClass]="(trade_name.invalid && (trade_name.dirty || trade_name.touched)) ? 'form-control is-invalid' : (trade_name.valid)? 'form-control is-valid':'form-control'"
                            formControlName="trade_name" id="trade_name" placeholder="">
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="email" class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Email address</label>
                    <div class="col-sm-8">
                        <input type="text" required
                            [ngClass]="(email.invalid && (email.dirty || email.touched)) ? 'form-control is-invalid' : (email.valid)? 'form-control is-valid':'form-control'"
                            formControlName="email" id="email" placeholder="">
                        <div *ngIf="email.invalid && (email.dirty || email.touched)" class="invalid-feedback">
                            <div *ngIf="email.errors.required">Email address is required</div>
                            <div *ngIf="email.errors.email">E-Mail is invalid</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="phone" class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Telephone
                        number</label>
                    <div class="col-sm-8">
                        <input type="text" required
                            [ngClass]="(phone.invalid && (phone.dirty || phone.touched)) ? 'form-control is-invalid' : (phone.valid)? 'form-control is-valid':'form-control'"
                            formControlName="phone" id="phone" placeholder="+X (XXX) XXX XXXX"
                            (input)="formatPhoneNumber(companyDetailsForm, 'phone')">
                        <div *ngIf="phone.invalid && (phone.dirty || phone.touched)" class="invalid-feedback">
                            <div *ngIf="phone.errors.required">Telephone number is required</div>
                            <div *ngIf="phone.errors.phoneNumberInvalid">Invalid phone number format. Please use +X
                                (XXX) XXX XXXX.</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="whatsapp"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">WhatsApp</label>
                    <div class="col-sm-8">
                        <input type="text" required
                            [ngClass]="(whatsapp.invalid && (whatsapp.dirty || whatsapp.touched)) ? 'form-control is-invalid' : (whatsapp.valid)? 'form-control is-valid':'form-control'"
                            formControlName="whatsapp" id="whatsapp" placeholder="+X (XXX) XXX XXXX"
                            (input)="formatPhoneNumber(companyDetailsForm, 'whatsapp')">
                        <div *ngIf="whatsapp.invalid && (whatsapp.dirty || whatsapp.touched)" class="invalid-feedback">
                            <div *ngIf="whatsapp.errors.required">WhatsApp number is required</div>
                            <div *ngIf="whatsapp.errors.phoneNumberInvalid">Invalid phone number format. Please use +X
                                (XXX) XXX XXXX.</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="object" class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Object of the
                        Company</label>
                    <div class="col-sm-8">
                        <input type="text" required
                            [ngClass]="(object.invalid && (object.dirty || object.touched)) ? 'form-control is-invalid' : (object.valid)? 'form-control is-valid':'form-control'"
                            formControlName="object" id="object" placeholder="">
                        <div *ngIf="object.invalid && (object.dirty || object.touched)" class="invalid-feedback">
                            <div *ngIf="object.errors.required">Object of the Company is required</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="purpose" class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Purpose of the Company</label>
                    <div class="col-sm-8">
                        <input type="text" required
                            [ngClass]="(purpose.invalid && (purpose.dirty || purpose.touched)) ? 'form-control is-invalid' : (purpose.valid)? 'form-control is-valid':'form-control'"
                            formControlName="purpose" id="purpose" placeholder="">
                        <div *ngIf="purpose.invalid && (purpose.dirty || purpose.touched)" class="invalid-feedback">
                            <div *ngIf="purpose.errors.required">Purpose of the company is required</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="financial_year"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Financial Year End</label>
                    <div class="col-sm-8">
                        <input type="text" required
                            [ngClass]="(financial_year.invalid && (financial_year.dirty || financial_year.touched)) ? 'form-control is-invalid' : (financial_year.valid)? 'form-control is-valid':'form-control'"
                            formControlName="financial_year" id="financial_year" placeholder="">
                        <div *ngIf="financial_year.invalid && (financial_year.dirty || financial_year.touched)"
                            class="invalid-feedback">
                            <div *ngIf="financial_year.errors.required">Financial year end is required</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="branche_affiliate"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Branches/Affiliates/Sister
                        Companies (if any)</label>
                    <div class="col-sm-8">
                        <input type="text"
                            [ngClass]="(branche_affiliate.invalid && (branche_affiliate.dirty || branche_affiliate.touched)) ? 'form-control is-invalid' : (branche_affiliate.valid)? 'form-control is-valid':'form-control'"
                            formControlName="branche_affiliate" id="branche_affiliate" placeholder="">
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="license_body" class="col-sm-4 col-form-label col-form-label-sm text-sm-start">License Issuing Body</label>
                    <div class="col-sm-8">
                        <input type="text"
                            [ngClass]="(license_body.invalid && (license_body.dirty || license_body.touched)) ? 'form-control is-invalid' : (license_body.valid)? 'form-control is-valid':'form-control'"
                            formControlName="license_body" id="license_body" placeholder="">
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="license_number" class="col-sm-4 col-form-label col-form-label-sm text-sm-start">License Number</label>
                    <div class="col-sm-8">
                        <input type="text"
                            [ngClass]="(license_number.invalid && (license_number.dirty || license_number.touched)) ? 'form-control is-invalid' : (license_number.valid)? 'form-control is-valid':'form-control'"
                            formControlName="license_number" id="license_number" placeholder="">
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="regulator" class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Regulatory Body/Authority</label>
                    <div class="col-sm-8">
                        <input type="text"
                            [ngClass]="(regulator.invalid && (regulator.dirty || regulator.touched)) ? 'form-control is-invalid' : (regulator.valid)? 'form-control is-valid':'form-control'"
                            formControlName="regulator" id="regulator" placeholder="">
                    </div>
                </div>

                <!-- Buttons at the bottom -->
                <div class="button-wrapper d-flex justify-content-between">
                    <input type="hidden" formControlName="companyDetailsFormRef" id="companyDetailsFormRef">
                    <button type="button" (click)="buttonAction('')" class="btn btn-outline-warning"
                        disabled>Back</button>
                    <button type="button"
                        [disabled]="!companyDetailsForm.valid || companyDetailsForm.pending || processing"
                        (click)="buttonAction('companyDetailsForm')" class="btn btn-warning">{{buttonName}}</button>
                </div>
            </form>
            <div [hidden]="!directorDetails" class="space-y-4 border-t-[1px] border-[#D8D8D8] mt-4">

                <div class="alert alert-danger" role="alert" *ngIf="userData.validation.directorDetails.status.rejected">
                    <b>{{commentError}}</b>
                    
                    <hr *ngIf="userData.validation.directorDetails.comment.length > 0">
                    <div *ngFor="let commentRow of userData.validation.directorDetails.comment; index as i">
                        <span [innerHTML]="commentRow.comment"></span>
                        <br>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <a [routerLink]="" data-bs-toggle="modal" data-bs-target="#modal-add-director"
                        class="btn btn-secondary">Add New Director</a><br>
                </div>
                <div class="overflow-auto border-[1px] border-[#BEBEBE] rounded-lg shadow text-[16.49px] mb-4">
                    <table class="table table-bordered w-full">
                        <thead class="bg-gray-100 border-b-[1px] border-[#BEBEBE]">
                            <tr>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">#
                                </th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">Name
                                </th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">
                                    Designation</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">email
                                </th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">phone
                                </th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">
                                    &nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let directorRow of userData.directorDetails; index as i">
                                <td>{{i+1}}</td>
                                <td>{{directorRow.name}}</td>
                                <td>{{directorRow.designation}}</td>
                                <td>{{directorRow.email}}</td>
                                <td>{{directorRow.phone}}</td>
                                <td><a [routerLink]="" data-bs-toggle="modal" data-bs-target="#modal-add-director"
                                        (click)='getEditDirector(directorRow)' class="btn btn-warning">edit</a> | <a
                                        class="btn btn-danger" [routerLink]="" data-bs-toggle="modal"
                                        data-bs-target="#modal-delete-director"
                                        (click)="getDataFromList(directorRow.name, directorRow.ref)"><i
                                            class="fas fa-trash-alt"></i> Remove</a></td>
                            </tr>

                            <tr *ngIf="userData.directorDetails.length == 0">
                                <td colspan="6" class="text-center">No record to show</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Buttons at the bottom -->
                <div class="button-wrapper d-flex justify-content-between">
                    <input type="hidden" formControlName="companyDetailsFormRef" id="companyDetailsFormRef">
                    <button type="button" (click)="buttonAction('companyDetailsBack')"
                        class="btn btn-outline-warning">Back</button>
                    <button type="button" [disabled]="processing || userData.directorDetails.length == 0"
                        (click)="buttonAction('directorDetailsForm')" class="btn btn-warning">{{buttonName}}</button>
                </div>
            </div>
            <div [hidden]="!contactPersonDetails" class="space-y-4 border-t-[1px] border-[#D8D8D8] mt-4">
                <div class="alert alert-danger" role="alert" *ngIf="userData.validation.contactPersonDetails.status.rejected">
                    <b>{{commentError}}</b>
                    
                    <hr *ngIf="userData.validation.contactPersonDetails.comment.length > 0">
                    <div *ngFor="let commentRow of userData.validation.contactPersonDetails.comment; index as i">
                        <span [innerHTML]="commentRow.comment"></span>
                        <br>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <a [routerLink]="" data-bs-toggle="modal" data-bs-target="#modal-add-contact"
                        class="btn btn-secondary">Add New Contact</a><br>
                </div>
                <div class="overflow-auto border-[1px] border-[#BEBEBE] rounded-lg shadow text-[16.49px] mb-4">
                    <table class="table table-bordered w-full">
                        <thead class="bg-gray-100 border-b-[1px] border-[#BEBEBE]">
                            <tr>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">#
                                </th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">Name
                                </th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">
                                    Designation</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">email
                                </th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">phone
                                </th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">
                                    &nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let contactRow of userData.contactPersons; index as i">
                                <td>{{i+1}}</td>
                                <td>{{contactRow.name}}</td>
                                <td>{{contactRow.designation}}</td>
                                <td>{{contactRow.email}}</td>
                                <td>{{contactRow.phone}}</td>
                                <td><a [routerLink]="" data-bs-toggle="modal" data-bs-target="#modal-add-contact"
                                        (click)='getEditContact(contactRow)' class="btn btn-warning">edit</a> | <a
                                        class="btn btn-danger" data-bs-toggle="modal"
                                        data-bs-target="#modal-delete-contact"
                                        (click)="getDataFromList(contactRow.name, contactRow.ref)"><i
                                            class="fas fa-trash-alt"></i> Remove</a></td>
                            </tr>

                            <tr *ngIf="userData.contactPersons.length == 0">
                                <td colspan="6" class="text-center">No record to show</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Buttons at the bottom -->
                <div class="button-wrapper d-flex justify-content-between">
                    <input type="hidden" formControlName="companyDetailsFormRef" id="companyDetailsFormRef">
                    <button type="button" (click)="buttonAction('directorDetailsBack')"
                        class="btn btn-outline-warning">Back</button>
                    <button type="button" [disabled]="processing || userData.contactPersons.length == 0"
                        (click)="buttonAction('contactPersonDetailsForm')"
                        class="btn btn-warning">{{buttonName}}</button>
                </div>
            </div>
            <div [hidden]="!ownershipDetails" class="space-y-4 border-t-[1px] border-[#D8D8D8] mt-4">
                <div class="d-flex justify-content-between align-items-center">
                    <p class="font-semibold text-[18px] md:text-[32px]">
                        Ownership and Shareholding
                    </p>
                    <a [hidden]="addShareHolder >= 100" [routerLink]="" data-bs-toggle="modal"
                        data-bs-target="#modal-add-owner" class="btn btn-secondary">Add New Shareholder</a>
                </div>

                <div class="alert alert-danger" role="alert" *ngIf="userData.validation.ownershipDetails.status.rejected">
                    <b>{{commentError}}</b>
                    
                    <hr *ngIf="userData.validation.ownershipDetails.comment.length > 0">
                    <div *ngFor="let commentRow of userData.validation.ownershipDetails.comment; index as i">
                        <span [innerHTML]="commentRow.comment"></span>
                        <br>
                    </div>
                </div>
                <div class="overflow-auto border-[1px] border-[#BEBEBE] rounded-lg shadow text-[16.49px] mb-4">
                    <table class="table table-bordered w-full">
                        <thead class="bg-gray-100 border-b-[1px] border-[#BEBEBE]">
                            <tr>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">#</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">Name</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">Percentage shareholding /voting rights</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let ownerRow of userData.ownership; index as i">
                                <td [ngClass]="findErrorRow(userData.validation.ownershipDetails.comment, 'UserOwner', ownerRow.ref) ? 'text-red' : ''">{{i+1}}</td>
                                <td [ngClass]="findErrorRow(userData.validation.ownershipDetails.comment, 'UserOwner', ownerRow.ref) ? 'text-red' : ''">{{ownerRow.name}} <i [hidden]="!ownerRow.politicallyExposed" class="fa fa-gavel" aria-hidden="true"></i></td>
                                <td [ngClass]="findErrorRow(userData.validation.ownershipDetails.comment, 'UserOwner', ownerRow.ref) ? 'text-red' : ''">{{ownerRow.shareholding}}</td>
                                <td [ngClass]="findErrorRow(userData.validation.ownershipDetails.comment, 'UserOwner', ownerRow.ref) ? 'text-red' : ''" class="text-end align-middle pe-3"><a [routerLink]="" data-bs-toggle="modal" data-bs-target="#modal-add-owner" (click)='getEditOwner(ownerRow)' class="btn btn-warning">edit</a> | <a class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#modal-delete-owner" (click)="getDataFromList(ownerRow.name, ownerRow.ref)"><i class="fas fa-trash-alt"></i> Remove</a></td>
                            </tr>
                            <tr *ngIf="userData.ownership.length == 0">
                                <td colspan="4" class="text-center">No record to show</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                    <p class="font-semibold text-[18px] md:text-[32px]">
                        Local Subsidiaries
                    </p>
                    <a [routerLink]="" data-bs-toggle="modal" data-bs-target="#modal-add-local"
                        class="btn btn-secondary">Add New Subsidiary</a>
                </div>
                <div class="alert alert-danger" role="alert" *ngIf="userData.validation.localBranchDetails.status.rejected">
                    <b>{{commentError}}</b>
                    
                    <hr *ngIf="userData.validation.localBranchDetails.comment.length > 0">
                    <div *ngFor="let commentRow of userData.validation.localBranchDetails.comment; index as i">
                        <span [innerHTML]="commentRow.comment"></span>
                        <br>
                    </div>
                </div>
                <div class="overflow-auto border-[1px] border-[#BEBEBE] rounded-lg shadow text-[16.49px] mb-4">
                    <table class="table table-bordered w-full">
                        <thead class="bg-gray-100 border-b-[1px] border-[#BEBEBE]">
                            <tr>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">#</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">Name</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">Address</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let ownerRow of userData.localSubsidiary; index as i">
                                <td [ngClass]="findErrorRow(userData.validation.localBranchDetails.comment, 'UserLocalBranch', ownerRow.ref) ? 'text-red' : ''">{{i+1}}</td>
                                <td [ngClass]="findErrorRow(userData.validation.localBranchDetails.comment, 'UserLocalBranch', ownerRow.ref) ? 'text-red' : ''">{{ownerRow.name}}</td>
                                <td [ngClass]="findErrorRow(userData.validation.localBranchDetails.comment, 'UserLocalBranch', ownerRow.ref) ? 'text-red' : ''">{{ownerRow.address}}</td>
                                <td [ngClass]="findErrorRow(userData.validation.localBranchDetails.comment, 'UserLocalBranch', ownerRow.ref) ? 'text-red' : ''" class="text-end align-middle pe-3"><a [routerLink]="" data-bs-toggle="modal" data-bs-target="#modal-add-local" (click)='getEditLocal(ownerRow)' class="btn btn-warning">edit</a> | <a class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#modal-delete-local" (click)="getDataFromList(ownerRow.name, ownerRow.ref)"><i class="fas fa-trash-alt"></i> Remove</a></td>
                            </tr>

                            <tr *ngIf="userData.localSubsidiary.length == 0">
                                <td colspan="4" class="text-center">No record to show</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                    <p class="font-semibold text-[18px] md:text-[32px]">
                        International Subsidiaries
                    </p>
                    <a [routerLink]="" data-bs-toggle="modal" data-bs-target="#modal-add-intl"
                        class="btn btn-secondary">Add New Subsidiary</a>
                </div>
                <div class="alert alert-danger" role="alert" *ngIf="userData.validation.internationalBDetails.status.rejected">
                    <b>{{commentError}}</b>
                    
                    <hr *ngIf="userData.validation.internationalBDetails.comment.length > 0">
                    <div *ngFor="let commentRow of userData.validation.internationalBDetails.comment; index as i">
                        <span [innerHTML]="commentRow.comment"></span>
                        <br>
                    </div>
                </div>

                <div class="overflow-auto border-[1px] border-[#BEBEBE] rounded-lg shadow text-[16.49px] mb-4">
                    <table class="table table-bordered w-full">
                        <thead class="bg-gray-100 border-b-[1px] border-[#BEBEBE]">
                            <tr>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">#</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">Name</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">Address</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">Country</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let ownerRow of userData.intSubsidiary; index as i">
                                <td [ngClass]="findErrorRow(userData.validation.internationalBDetails.comment, 'UserInternationalB', ownerRow.ref) ? 'text-red' : ''">{{i+1}}</td>
                                <td [ngClass]="findErrorRow(userData.validation.internationalBDetails.comment, 'UserInternationalB', ownerRow.ref) ? 'text-red' : ''">{{ownerRow.name}}</td>
                                <td [ngClass]="findErrorRow(userData.validation.internationalBDetails.comment, 'UserInternationalB', ownerRow.ref) ? 'text-red' : ''">{{ownerRow.address}}</td>
                                <td [ngClass]="findErrorRow(userData.validation.internationalBDetails.comment, 'UserInternationalB', ownerRow.ref) ? 'text-red' : ''">{{ownerRow.country}}</td>
                                <td [ngClass]="findErrorRow(userData.validation.internationalBDetails.comment, 'UserInternationalB', ownerRow.ref) ? 'text-red' : ''" class="text-end align-middle pe-3">
                                    <a [routerLink]="" data-bs-toggle="modal" data-bs-target="#modal-add-intl" (click)='getEditIntl(ownerRow)' class="btn btn-warning">edit</a> | <a class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#modal-delete-intl" (click)="getDataFromList(ownerRow.name, ownerRow.ref)"><i class="fas fa-trash-alt"></i> Remove</a>
                                </td>
                            </tr>

                            <tr *ngIf="userData.intSubsidiary.length == 0">
                                <td colspan="5" class="text-center">No record to show</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                    <p class="font-semibold text-[18px] md:text-[32px]">
                        Related Party/Entity
                    </p>
                    <a [routerLink]="" data-bs-toggle="modal" data-bs-target="#modal-add-related"
                        class="btn btn-secondary">Add New Party/Entity</a>
                </div>
                <div class="alert alert-danger" role="alert" *ngIf="userData.validation.relatedEntityDetails.status.rejected">
                    <b>{{commentError}}</b>
                    
                    <hr *ngIf="userData.validation.relatedEntityDetails.comment.length > 0">
                    <div *ngFor="let commentRow of userData.validation.relatedEntityDetails.comment; index as i">
                        <span [innerHTML]="commentRow.comment"></span>
                        <br>
                    </div>
                </div>

                <div class="overflow-auto border-[1px] border-[#BEBEBE] rounded-lg shadow text-[16.49px] mb-4">
                    <table class="table table-bordered w-full">
                        <thead class="bg-gray-100 border-b-[1px] border-[#BEBEBE]">
                            <tr>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">#</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">Name</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">Relationship</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">Nationality</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">director</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let ownerRow of userData.relatedEntity; index as i">
                                <td [ngClass]="findErrorRow(userData.validation.relatedEntityDetails.comment, 'UserRelatedEntity', ownerRow.ref) ? 'text-red' : ''">{{i+1}}</td>
                                <td [ngClass]="findErrorRow(userData.validation.relatedEntityDetails.comment, 'UserRelatedEntity', ownerRow.ref) ? 'text-red' : ''">{{ownerRow.name}}</td>
                                <td [ngClass]="findErrorRow(userData.validation.relatedEntityDetails.comment, 'UserRelatedEntity', ownerRow.ref) ? 'text-red' : ''">{{ownerRow.nationality}}</td>
                                <td [ngClass]="findErrorRow(userData.validation.relatedEntityDetails.comment, 'UserRelatedEntity', ownerRow.ref) ? 'text-red' : ''">{{ownerRow.nature}}</td>
                                <td [ngClass]="findErrorRow(userData.validation.relatedEntityDetails.comment, 'UserRelatedEntity', ownerRow.ref) ? 'text-red' : ''">{{ownerRow.director.length}}</td>
                                <td [ngClass]="findErrorRow(userData.validation.relatedEntityDetails.comment, 'UserRelatedEntity', ownerRow.ref) ? 'text-red' : ''" class="text-end align-middle pe-3">
                                    <a [routerLink]="" data-bs-toggle="modal" data-bs-target="#modal-add-related" (click)='getEditRelated(ownerRow)' class="btn btn-warning">edit</a> | <a class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#modal-delete-related" (click)="getDataFromList(ownerRow.name, ownerRow.ref)"><i class="fas fa-trash-alt"></i> Remove</a>
                                </td>
                            </tr>

                            <tr *ngIf="userData.relatedEntity.length == 0">
                                <td colspan="6" class="text-center">No record to show</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                    <p class="font-semibold text-[18px] md:text-[32px]">
                        Bank Accounts
                    </p>
                    <a [routerLink]="" data-toggle="modal" data-bs-toggle="modal" data-bs-target="#modal-add-bank"
                        class="btn btn-secondary">Add New Bank Account</a>
                </div>
                <div class="alert alert-danger" role="alert" *ngIf="userData.validation.bankAccountDetails.status.rejected">
                    <b>{{commentError}}</b>
                    
                    <hr *ngIf="userData.validation.bankAccountDetails.comment.length > 0">
                    <div *ngFor="let commentRow of userData.validation.bankAccountDetails.comment; index as i">
                        <span [innerHTML]="commentRow.comment"></span>
                        <br>
                    </div>
                </div>

                <div class="overflow-auto border-[1px] border-[#BEBEBE] rounded-lg shadow text-[16.49px] mb-4">
                    <table class="table table-bordered w-full">
                        <thead class="bg-gray-100 border-b-[1px] border-[#BEBEBE]">
                            <tr>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">#</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">Bank Name</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">Account Number</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">Account Type</th>
                                <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let ownerRow of userData.bankAccounts; index as i">
                                <td [ngClass]="findErrorRow(userData.validation.bankAccountDetails.comment, 'UserBankAccount', ownerRow.ref) ? 'text-red' : ''">{{i+1}}</td>
                                <td [ngClass]="findErrorRow(userData.validation.bankAccountDetails.comment, 'UserBankAccount', ownerRow.ref) ? 'text-red' : ''">{{ownerRow.bankName}}</td>
                                <td [ngClass]="findErrorRow(userData.validation.bankAccountDetails.comment, 'UserBankAccount', ownerRow.ref) ? 'text-red' : ''">{{ownerRow.accountNumber}}</td>
                                <td [ngClass]="findErrorRow(userData.validation.bankAccountDetails.comment, 'UserBankAccount', ownerRow.ref) ? 'text-red' : ''">{{ownerRow.accountType}}</td>
                                <td [ngClass]="findErrorRow(userData.validation.bankAccountDetails.comment, 'UserBankAccount', ownerRow.ref) ? 'text-red' : ''" class="text-end align-middle pe-3">
                                    <a [routerLink]="" data-bs-toggle="modal" data-bs-target="#modal-add-bank" (click)='getEditBankAccount(ownerRow)' class="btn btn-warning">edit</a> | <a class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#modal-delete-bank" (click)="getDataFromList(ownerRow.accountNumber, ownerRow.ref)"><i class="fas fa-trash-alt"></i> Remove</a>
                                </td>
                            </tr>

                            <tr *ngIf="userData.bankAccounts.length == 0">
                                <td colspan="5" class="text-center">No record to show</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- Buttons at the bottom -->
                <div class="button-wrapper d-flex justify-content-between">
                    <input type="hidden" formControlName="companyDetailsFormRef" id="companyDetailsFormRef">
                    <button type="button" (click)="buttonAction('ownershipDetailsBack')"
                        class="btn btn-outline-warning">Back</button>
                    <button type="button" [disabled]="processing || userData.ownership.length == 0"
                        (click)="buttonAction('ownershipDetailsForm')" class="btn btn-warning">{{buttonName}}</button>
                </div>
            </div>
            <form [formGroup]="transactionDetailsForm" [hidden]="!transactionDetails" class="space-y-4 border-t-[1px] border-[#D8D8D8] mt-4">
                <div class="alert alert-danger" role="alert" *ngIf="userData.validation.transactionDetails.status.rejected">
                    <b>{{commentError}}</b>
                    
                    <hr *ngIf="userData.validation.transactionDetails.comment.length > 0">
                    <div *ngFor="let commentRow of userData.validation.transactionDetails.comment; index as i">
                        <span [innerHTML]="commentRow.comment"></span>
                        <br>
                    </div>
                </div>
                <!-- Form Group 1 -->
                <div class="row mb-3">
                    <label for="transaction_origin"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Please confirm the origin of the
                        funds normally received into your accounts.E.g. business profits, savings, dividend income
                        etc</label>
                    <div class="col-sm-8">
                        <input type="text" required
                            [ngClass]="(transaction_origin.invalid && (transaction_origin.dirty || transaction_origin.touched)) ? 'form-control is-invalid' : (transaction_origin.valid)? 'form-control is-valid':'form-control'"
                            formControlName="transaction_origin" id="transaction_origin" placeholder="">
                        <div *ngIf="transaction_origin.invalid && (transaction_origin.dirty || transaction_origin.touched)"
                            class="invalid-feedback">
                            <div *ngIf="transaction_origin.errors.required">Origin of funds is required</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 2 -->
                <div class="row mb-3">
                    <label for="transaction_purpose"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Please confirm the purpose of
                        the business relationship with 7th Haven Finance Inc</label>
                    <div class="col-sm-8">
                        <textarea required
                            [ngClass]="(transaction_purpose.invalid && (transaction_purpose.dirty || transaction_purpose.touched)) ? 'form-control is-invalid' : (transaction_purpose.valid)? 'form-control is-valid':'form-control'"
                            formControlName="transaction_purpose" id="transaction_purpose" placeholder="">
                        </textarea>
                        <div *ngIf="transaction_purpose.invalid && (transaction_purpose.dirty || transaction_purpose.touched)"
                            class="invalid-feedback">
                            <div *ngIf="transaction_purpose.errors.required">purpose of the business relationship is
                                required</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="transaction_application"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Confirm the application of funds
                        from 7th Haven Finance Inc.</label>
                    <div class="col-sm-8">
                        <input type="text" required
                            [ngClass]="(transaction_application.invalid && (transaction_application.dirty || transaction_application.touched)) ? 'form-control is-invalid' : (transaction_application.valid)? 'form-control is-valid':'form-control'"
                            formControlName="transaction_application" id="transaction_application" placeholder="">
                        <div *ngIf="transaction_application.invalid && (transaction_application.dirty || transaction_application.touched)"
                            class="invalid-feedback">
                            <div *ngIf="transaction_application.errors.required">application of funds is required</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="transaction_is_licence"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Is there a requirement to obtain
                        authority or License before proceeding with this transaction</label>
                    <div class="col-sm-8">
                        <select required
                            [ngClass]="(transaction_is_licence.invalid && (transaction_is_licence.dirty || transaction_is_licence.touched)) ? 'form-control is-invalid' : (transaction_is_licence.valid)? 'form-control is-valid':'form-control'"
                            formControlName="transaction_is_licence" id="transaction_is_licence">
                            <option value="">Select One</option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                        <div *ngIf="transaction_is_licence.invalid && (transaction_is_licence.dirty || transaction_is_licence.touched)"
                            class="invalid-feedback">
                            <div *ngIf="transaction_is_licence.errors.required">license, requirement is required</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="transaction_licence_authority"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">License issuing authority</label>
                    <div class="col-sm-8">
                        <input type="text" required
                            [ngClass]="(transaction_licence_authority.invalid && (transaction_licence_authority.dirty || transaction_licence_authority.touched)) ? 'form-control is-invalid' : (transaction_licence_authority.valid)? 'form-control is-valid':'form-control'"
                            formControlName="transaction_licence_authority" id="transaction_licence_authority"
                            placeholder="">
                        <div *ngIf="transaction_licence_authority.invalid && (transaction_licence_authority.dirty || transaction_licence_authority.touched)"
                            class="invalid-feedback">
                            <div *ngIf="transaction_licence_authority.errors.required">License issuing authority is required</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="transaction_licence_number"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">License number</label>
                    <div class="col-sm-8">
                        <input type="text" required
                            [ngClass]="(transaction_licence_number.invalid && (transaction_licence_number.dirty || transaction_licence_number.touched)) ? 'form-control is-invalid' : (transaction_licence_number.valid)? 'form-control is-valid':'form-control'"
                            formControlName="transaction_licence_number" id="transaction_licence_number" placeholder="">
                        <div *ngIf="transaction_licence_number.invalid && (transaction_licence_number.dirty || transaction_licence_number.touched)"
                            class="invalid-feedback">
                            <div *ngIf="transaction_licence_number.errors.required">license number is required</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="transaction_volume"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Expected monthly transactions volume ($)</label>
                    <div class="col-sm-8">
                        <select required
                            [ngClass]="(transaction_volume.invalid && (transaction_volume.dirty || transaction_volume.touched)) ? 'form-control is-invalid' : (transaction_volume.valid)? 'form-control is-valid':'form-control'"
                            formControlName="transaction_volume" id="transaction_volume">
                            <option value="">Select One</option>
                            <option value="Under $100,000">Under $100,000</option>
                            <option value="$100,000 - $500,000">$100,000 - $500,000</option>
                            <option value="$100,000 - $500,000">$100,000 - $500,000</option>
                            <option value="$1 million - $5 million">$1 million - $5 million</option>
                            <option value="$5 million - $10 million">$5 million - $10 million</option>
                            <option value="Over $10 million">Over $10 million</option>
                        </select>
                        <div *ngIf="transaction_volume.invalid && (transaction_volume.dirty || transaction_volume.touched)"
                            class="invalid-feedback">
                            <div *ngIf="transaction_volume.errors.required">Expected monthly transactions volume is required</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="transaction_annual_revenue"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Expected Annual Revenue ($)</label>
                    <div class="col-sm-8">

                        <select required
                            [ngClass]="(transaction_annual_revenue.invalid && (transaction_annual_revenue.dirty || transaction_annual_revenue.touched)) ? 'form-control is-invalid' : (transaction_annual_revenue.valid)? 'form-control is-valid':'form-control'"
                            formControlName="transaction_annual_revenue" id="transaction_annual_revenue">
                            <option value="">Select One</option>
                            <option value="Under $100,000">Under $100,000</option>
                            <option value="$100,000 - $500,000">$100,000 - $500,000</option>
                            <option value="$100,000 - $500,000">$100,000 - $500,000</option>
                            <option value="$1 million - $5 million">$1 million - $5 million</option>
                            <option value="$5 million - $10 million">$5 million - $10 million</option>
                            <option value="Over $10 million">Over $10 million</option>
                        </select>
                        <div *ngIf="transaction_annual_revenue.invalid && (transaction_annual_revenue.dirty || transaction_annual_revenue.touched)"
                            class="invalid-feedback">
                            <div *ngIf="transaction_annual_revenue.errors.required">Expected Annual Revenue</div>
                        </div>
                    </div>
                </div>

                <!-- Buttons at the bottom -->
                <div class="button-wrapper d-flex justify-content-between">
                    <input type="hidden" formControlName="transaction_ref" id="transaction_ref">
                    <button type="button" (click)="buttonAction('transactionDetailsBack')"
                        class="btn btn-outline-warning">Back</button>
                    <button type="button"
                        [disabled]="!transactionDetailsForm.valid || transactionDetailsForm.pending || processing"
                        (click)="buttonAction('transactionDetailsForm')" class="btn btn-warning">{{buttonName}}</button>
                </div>
            </form>
            <form [formGroup]="complianceDetailsForm" [hidden]="!complianceDetails" class="space-y-4 border-t-[1px] border-[#D8D8D8] mt-4">
                <div class="alert alert-danger" role="alert" *ngIf="userData.validation.complianceDetails.status.rejected">
                    <b>{{commentError}}</b>
                    
                    <hr *ngIf="userData.validation.complianceDetails.comment.length > 0">
                    <div *ngFor="let commentRow of userData.validation.complianceDetails.comment; index as i">
                        <span [innerHTML]="commentRow.comment"></span>
                        <br>
                    </div>
                </div>
                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="compliance_policy_status"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Do you have a Compliance Policy?</label>
                    <div class="col-sm-8">
                        <select required
                            [ngClass]="(compliance_policy_status.invalid && (compliance_policy_status.dirty || compliance_policy_status.touched)) ? 'form-control is-invalid' : (compliance_policy_status.valid)? 'form-control is-valid':'form-control'"
                            formControlName="compliance_policy_status" id="compliance_policy_status">
                            <option value="">Select One</option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                        <div *ngIf="compliance_policy_status.invalid && (compliance_policy_status.dirty || compliance_policy_status.touched)"
                            class="invalid-feedback">
                            <div *ngIf="compliance_policy_status.errors.required">Compliance policy requirement is
                                required</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="compliance_policy_notes"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">If No, please explain</label>
                    <div class="col-sm-8">
                        <input type="text" required
                            [ngClass]="(compliance_policy_notes.invalid && (compliance_policy_notes.dirty || compliance_policy_notes.touched)) ? 'form-control is-invalid' : (compliance_policy_notes.valid)? 'form-control is-valid':'form-control'"
                            formControlName="compliance_policy_notes" id="compliance_policy_notes" placeholder="">
                        <div *ngIf="compliance_policy_notes.invalid && (compliance_policy_notes.dirty || compliance_policy_notes.touched)"
                            class="invalid-feedback">
                            <div *ngIf="compliance_policy_notes.errors.required">please explain</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="compliance_aml_status"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Do you carry out AML/CFT checks
                        before onboarding clients?</label>
                    <div class="col-sm-8">
                        <select required
                            [ngClass]="(compliance_aml_status.invalid && (compliance_aml_status.dirty || compliance_aml_status.touched)) ? 'form-control is-invalid' : (compliance_aml_status.valid)? 'form-control is-valid':'form-control'"
                            formControlName="compliance_aml_status" id="compliance_aml_status">
                            <option value="">Select One</option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                        <div *ngIf="compliance_aml_status.invalid && (compliance_aml_status.dirty || compliance_aml_status.touched)"
                            class="invalid-feedback">
                            <div *ngIf="compliance_aml_status.errors.required">AML/CFT checks requirement is required
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="compliance_aml_notes" class="col-sm-4 col-form-label col-form-label-sm text-sm-start">If
                        No, please explain</label>
                    <div class="col-sm-8">
                        <input type="text" required
                            [ngClass]="(compliance_aml_notes.invalid && (compliance_aml_notes.dirty || compliance_aml_notes.touched)) ? 'form-control is-invalid' : (compliance_aml_notes.valid)? 'form-control is-valid':'form-control'"
                            formControlName="compliance_aml_notes" id="compliance_aml_notes" placeholder="">
                        <div *ngIf="compliance_aml_notes.invalid && (compliance_aml_notes.dirty || compliance_aml_notes.touched)"
                            class="invalid-feedback">
                            <div *ngIf="compliance_aml_notes.errors.required">please explain</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="compliance_dueDilligence_status"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Do you carry out enhanced due
                        diligence on PEPs, Government Officials, Non-nationals etc. before onboarding?</label>
                    <div class="col-sm-8">
                        <select required
                            [ngClass]="(compliance_dueDilligence_status.invalid && (compliance_dueDilligence_status.dirty || compliance_dueDilligence_status.touched)) ? 'form-control is-invalid' : (compliance_dueDilligence_status.valid)? 'form-control is-valid':'form-control'"
                            formControlName="compliance_dueDilligence_status" id="compliance_dueDilligence_status">
                            <option value="">Select One</option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                        <div *ngIf="compliance_dueDilligence_status.invalid && (compliance_dueDilligence_status.dirty || compliance_dueDilligence_status.touched)"
                            class="invalid-feedback">
                            <div *ngIf="compliance_dueDilligence_status.errors.required">due diligence requirement is
                                required</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="compliance_dueDilligence_notes"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">If No, please explain</label>
                    <div class="col-sm-8">
                        <input type="text" required
                            [ngClass]="(compliance_dueDilligence_notes.invalid && (compliance_dueDilligence_notes.dirty || compliance_dueDilligence_notes.touched)) ? 'form-control is-invalid' : (compliance_dueDilligence_notes.valid)? 'form-control is-valid':'form-control'"
                            formControlName="compliance_dueDilligence_notes" id="compliance_dueDilligence_notes"
                            placeholder="">
                        <div *ngIf="compliance_dueDilligence_notes.invalid && (compliance_dueDilligence_notes.dirty || compliance_dueDilligence_notes.touched)"
                            class="invalid-feedback">
                            <div *ngIf="compliance_dueDilligence_notes.errors.required">please explain</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="compliance_dataPrivacy_status"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Do you have a Data Privacy
                        Policy?</label>
                    <div class="col-sm-8">
                        <select required
                            [ngClass]="(compliance_dataPrivacy_status.invalid && (compliance_dataPrivacy_status.dirty || compliance_dataPrivacy_status.touched)) ? 'form-control is-invalid' : (compliance_dataPrivacy_status.valid)? 'form-control is-valid':'form-control'"
                            formControlName="compliance_dataPrivacy_status" id="compliance_dataPrivacy_status">
                            <option value="">Select One</option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                        <div *ngIf="compliance_dataPrivacy_status.invalid && (compliance_dataPrivacy_status.dirty || compliance_dataPrivacy_status.touched)"
                            class="invalid-feedback">
                            <div *ngIf="compliance_dataPrivacy_status.errors.required">Data privacy requirement is
                                required</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="compliance_dataPrivacy_notes"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">If No, please explain</label>
                    <div class="col-sm-8">
                        <input type="text" required
                            [ngClass]="(compliance_dataPrivacy_notes.invalid && (compliance_dataPrivacy_notes.dirty || compliance_dataPrivacy_notes.touched)) ? 'form-control is-invalid' : (compliance_dataPrivacy_notes.valid)? 'form-control is-valid':'form-control'"
                            formControlName="compliance_dataPrivacy_notes" id="compliance_dataPrivacy_notes"
                            placeholder="">
                        <div *ngIf="compliance_dataPrivacy_notes.invalid && (compliance_dataPrivacy_notes.dirty || compliance_dataPrivacy_notes.touched)"
                            class="invalid-feedback">
                            <div *ngIf="compliance_dataPrivacy_notes.errors.required">please explain</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="compliance_dispute_status"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">Are you subject to money
                        laundering/criminal investigation/significant dispute? </label>
                    <div class="col-sm-8">
                        <select required
                            [ngClass]="(compliance_dispute_status.invalid && (compliance_dispute_status.dirty || compliance_dispute_status.touched)) ? 'form-control is-invalid' : (compliance_dispute_status.valid)? 'form-control is-valid':'form-control'"
                            formControlName="compliance_dispute_status" id="compliance_dispute_status">
                            <option value="">Select One</option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                        <div *ngIf="compliance_dispute_status.invalid && (compliance_dispute_status.dirty || compliance_dispute_status.touched)"
                            class="invalid-feedback">
                            <div *ngIf="compliance_dispute_status.errors.required">money laundering/criminal
                                investigation/significant requirement is required</div>
                        </div>
                    </div>
                </div>

                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <label for="compliance_dispute_notes"
                        class="col-sm-4 col-form-label col-form-label-sm text-sm-start">If Yes, please explain</label>
                    <div class="col-sm-8">
                        <input type="text" required
                            [ngClass]="(compliance_dispute_notes.invalid && (compliance_dispute_notes.dirty || compliance_dispute_notes.touched)) ? 'form-control is-invalid' : (compliance_dispute_notes.valid)? 'form-control is-valid':'form-control'"
                            formControlName="compliance_dispute_notes" id="compliance_dispute_notes" placeholder="">
                        <div *ngIf="compliance_dispute_notes.invalid && (compliance_dispute_notes.dirty || compliance_dispute_notes.touched)"
                            class="invalid-feedback">
                            <div *ngIf="compliance_dispute_notes.errors.required">please explain</div>
                        </div>
                    </div>
                </div>

                <!-- Buttons at the bottom -->
                <div class="button-wrapper d-flex justify-content-between">
                    <input type="hidden" formControlName="compliance_ref" id="compliance_ref">
                    <button type="button" (click)="buttonAction('complianceDetailsBack')"
                        class="btn btn-outline-warning">Back</button>
                    <button type="button"
                        [disabled]="!complianceDetailsForm.valid || complianceDetailsForm.pending || processing"
                        (click)="buttonAction('complianceDetailsForm')" class="btn btn-warning">{{buttonName}}</button>
                </div>
            </form>
            <form [formGroup]="uploadFilesForm" [hidden]="!uploadFiles" class="space-y-4 border-t-[1px] border-[#D8D8D8] mt-4">

                <div class="alert alert-danger" role="alert" *ngIf="userData.validation.uploadFiles.status.rejected">
                    <b>{{commentError}}</b>
                    
                    <hr *ngIf="userData.validation.uploadFiles.comment.length > 0">
                    <div *ngFor="let commentRow of userData.validation.uploadFiles.comment; index as i">
                        <span [innerHTML]="commentRow.comment"></span>
                        <br>
                    </div>
                    <span><br>You need to delete the highlighted document and upload a new one</span>
                </div>
                <!-- Form Group 3 -->
                <div class="row mb-3">
                    <div class="col-sm-4 col-form-label col-form-label-sm text-sm-start">
                        <select required
                            [ngClass]="(userDocumentRef.invalid && (userDocumentRef.dirty || userDocumentRef.touched)) ? 'form-control is-invalid' : (userDocumentRef.valid)? 'form-control is-valid':'form-control'"
                            formControlName="userDocumentRef" id="userDocumentRef"
                            (change)="onOptionChange($event.target)">
                            <option value="">Select One</option>
                            <option *ngFor="let documentType of documentTypeArray; index as i"
                                [value]="documentType.userDocumentRef" [label]="documentType.label"
                                [attr.data-notes]="documentType.notes"></option>
                            <option value="0">Others</option>
                        </select>
                        <small>{{uploadLabel}}</small>
                        <div *ngIf="userDocumentRef.invalid && (userDocumentRef.dirty || userDocumentRef.touched)"
                            class="invalid-feedback">
                            <div *ngIf="userDocumentRef.errors.required">Please select file type</div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <input type="file" required
                            [ngClass]="(fileUpload.invalid && (fileUpload.dirty || fileUpload.touched)) ? 'form-control is-invalid' : (fileUpload.valid)? 'form-control is-valid':'form-control'"
                            formControlName="fileUpload" id="fileUpload" (change)="onFileChange($event)"
                            accept=".doc,.docx,.pdf,.png,.jpg,.jpeg">
                        <div *ngIf="fileUpload.invalid && (fileUpload.dirty || fileUpload.touched)"
                            class="invalid-feedback">
                            <div *ngIf="fileUpload.errors.required">file is required is required</div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <input type="hidden" formControlName="notes" id="notes">
                        <button type="button"
                            [disabled]="!uploadFilesForm.valid || uploadFilesForm.pending || processing"
                            (click)="onUpload()" class="btn btn-warning">{{uploadButton}}</button>
                    </div>
                </div>
                <table class="table table-bordered w-full">
                    <thead class="bg-gray-100 border-b-[1px] border-[#BEBEBE]">
                        <tr>
                            <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">#</th>
                            <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">Document
                                Type</th>
                            <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left">Document
                            </th>
                            <th class="p-3 border-r-[1px] font-light border-[#BEBEBE] tracking-wide text-left text-end">&nbsp;
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let ownerRow of userData.documents; index as i">
                            <td>{{i+1}}</td>
                            <td><i *ngIf="ownerRow.status.rejected" 
                        class="fas fa-exclamation-circle" style="color: red;" [style.color]="'red'" aria-hidden="true"></i> {{ownerRow.label}}</td>
                            <td><a [href]="ownerRow.url" [title]="ownerRow.documentType.title" target="_blank">Open File</a></td>
                            <td class="text-end align-middle pe-3">
                                <a class="btn btn-danger"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modal-delete-document"
                                    (click)="getDataFromList(ownerRow.documentType.title, ownerRow.ref)">
                                    <i class="fas fa-trash-alt"></i> Remove
                                </a>
                            </td>

                        <tr *ngIf="userData.documents.length == 0">
                            <td colspan="5" class="text-center">No record to show</td>
                        </tr>
                    </tbody>
                </table>
            </form>
        </div>
    </div>
</div>

<div class="modal fade" id="modal-submit-kyc">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Submit</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p
                    [innerHTML]="'This action will submit this form and your account will be pending and under review, you will get an email notifying you of the next steps, are you sure you want to continue ?'">
                </p>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-warning" (click)="submitKyc()">Submit</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<div class="modal fade" id="modal-add-director">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title"> {{directorTitle}}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form [formGroup]="directorDetailsForm">
                <div class="modal-body">
                    <div class="form-group">
                        <label for="director_name">Name</label>
                        <input type="text" required
                            [ngClass]="(director_name.invalid && (director_name.dirty || director_name.touched)) ? 'form-control is-invalid' : (director_name.valid)? 'form-control is-valid':'form-control'"
                            formControlName="director_name" id="director_name" placeholder="">
                        <div *ngIf="director_name.invalid && (director_name.dirty || director_name.touched)"
                            class="invalid-feedback">
                            <div *ngIf="director_name.errors.required">Name is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="director_designation">Designation</label>
                        <select required
                            [ngClass]="(director_designation.invalid && (director_designation.dirty || director_designation.touched)) ? 'form-control is-invalid' : (director_designation.valid)? 'form-control is-valid':'form-control'"
                            formControlName="director_designation" id="director_designation">
                            <option value="">Select One</option>
                            <option value="Director">Director</option>
                            <option value="Secretary">Secretary</option>
                        </select>
                        <div *ngIf="director_designation.invalid && (director_designation.dirty || director_designation.touched)"
                            class="invalid-feedback">
                            <div *ngIf="director_designation.errors.required">Designation is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="director_dob">Date of Birth</label>
                        <input type="date" required
                            [ngClass]="(director_dob.invalid && (director_dob.dirty || director_dob.touched)) ? 'form-control is-invalid' : (director_dob.valid)? 'form-control is-valid':'form-control'"
                            [max]="today"
                            formControlName="director_dob" id="director_dob" placeholder="">
                        <div *ngIf="director_dob.invalid && (director_dob.dirty || director_dob.touched)"
                            class="invalid-feedback">
                            <div *ngIf="director_dob.errors.required">Date of Birth is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="director_address">Address</label>
                        <textarea required
                            [ngClass]="(director_address.invalid && (director_address.dirty || director_address.touched)) ? 'form-control is-invalid' : (director_address.valid)? 'form-control is-valid':'form-control'"
                            formControlName="director_address" id="director_address" placeholder="">
                    </textarea>
                        <div *ngIf="director_address.invalid && (director_address.dirty || director_address.touched)"
                            class="invalid-feedback">
                            <div *ngIf="director_address.errors.required">address is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="email">E-Mail</label>
                        <input type="email" required
                            [ngClass]="(director_email.invalid && (director_email.dirty || director_email.touched)) ? 'form-control is-invalid' : (director_email.valid)? 'form-control is-valid':'form-control'"
                            formControlName="director_email" id="director_email" placeholder="someone@example.com">
                        <div *ngIf="director_email.invalid && (director_email.dirty || director_email.touched)"
                            class="invalid-feedback">
                            <div *ngIf="director_email.errors.required">E-Mail is required</div>
                            <div *ngIf="director_email.errors.email">E-Mail is invalid</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="phone">Phone Number</label>
                        <input type="text" required
                            [ngClass]="(director_phone.invalid && (director_phone.dirty || director_phone.touched)) ? 'form-control is-invalid' : (director_phone.valid)? 'form-control is-valid':'form-control'"
                            formControlName="director_phone" id="director_phone" placeholder="+X (XXX) XXX XXXX"
                            (input)="formatPhoneNumber(directorDetailsForm, 'director_phone')">
                        <div *ngIf="director_phone.invalid && (director_phone.dirty || director_phone.touched)"
                            class="invalid-feedback">
                            <div *ngIf="director_phone.errors.required">Phone number is required</div>
                            <div *ngIf="director_phone.errors.phoneNumberInvalid">Invalid phone number format. Please
                                use +X (XXX) XXX XXXX.</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="director_appointment_date">Appointment Date</label>
                        <input type="date" required
                            [ngClass]="(director_appointment_date.invalid && (director_appointment_date.dirty || director_appointment_date.touched)) ? 'form-control is-invalid' : (director_appointment_date.valid)? 'form-control is-valid':'form-control'"
                            formControlName="director_appointment_date" 
                            [max]="today" id="director_appointment_date" placeholder="">
                        <div *ngIf="director_appointment_date.invalid && (director_appointment_date.dirty || director_appointment_date.touched)"
                            class="invalid-feedback">
                            <div *ngIf="director_appointment_date.errors.required">Appointment Date is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="director_nationality">Nationality</label>
                        <input type="text" required
                            [ngClass]="(director_nationality.invalid && (director_nationality.dirty || director_nationality.touched)) ? 'form-control is-invalid' : (director_nationality.valid)? 'form-control is-valid':'form-control'"
                            formControlName="director_nationality" id="director_nationality" placeholder="">
                        <div *ngIf="director_nationality.invalid && (director_nationality.dirty || director_nationality.touched)"
                            class="invalid-feedback">
                            <div *ngIf="director_nationality.errors.required">Nationality is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="director_identification">Means of Identification</label>
                        <select required
                            [ngClass]="(director_identification.invalid && (director_identification.dirty || director_identification.touched)) ? 'form-control is-invalid' : (director_identification.valid)? 'form-control is-valid':'form-control'"
                            formControlName="director_identification" id="director_identification">
                            <option value="0">Select One</option>
                            <option *ngFor="let directorRow of userData.userSettings.identityDocument;" [value]="directorRow">
                                {{directorRow}}</option>
                        </select>
                        <div *ngIf="director_identification.invalid && (director_identification.dirty || director_identification.touched)"
                            class="invalid-feedback">
                            <div *ngIf="director_identification.errors.required">Means of Identification is required
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="director_bvn">BVN</label>
                        <input type="text" required
                            [ngClass]="(director_bvn.invalid && (director_bvn.dirty || director_bvn.touched)) ? 'form-control is-invalid' : (director_bvn.valid)? 'form-control is-valid':'form-control'"
                            formControlName="director_bvn" id="director_bvn" placeholder="">
                        <div *ngIf="director_bvn.invalid && (director_bvn.dirty || director_bvn.touched)"
                            class="invalid-feedback">
                            <div *ngIf="director_bvn.errors.required">Designation is required</div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <input type="hidden" formControlName="director_ref" id="director_ref">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                            (click)="onCancel()">Close</button>
                        <button type="button"
                            [disabled]="!directorDetailsForm.valid || directorDetailsForm.pending || processing"
                            (click)="onCreateDirector()" class="btn btn-warning">{{directoeButtonTex}}</button>
                    </div>
                </div>
            </form>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<div class="modal fade" id="modal-delete-director">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Remove {{userName}}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p
                    [innerHTML]="'This action will remove '+userName+'. This action is not reversable, are you sure you want to continue ?'">
                </p>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-danger" (click)="deleteDirector(userRef)">Delete Director</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

<div class="modal fade" id="modal-add-contact">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title"> {{contactTitle}}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form [formGroup]="contactPersonDetailsForm">
                <div class="modal-body">
                    <div class="form-group">
                        <label for="contact_name">Name</label>
                        <input type="text" required
                            [ngClass]="(contact_name.invalid && (contact_name.dirty || contact_name.touched)) ? 'form-control is-invalid' : (contact_name.valid)? 'form-control is-valid':'form-control'"
                            formControlName="contact_name" id="contact_name" placeholder="">
                        <div *ngIf="contact_name.invalid && (contact_name.dirty || contact_name.touched)"
                            class="invalid-feedback">
                            <div *ngIf="contact_name.errors.required">Name is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="contact_designation">Designation</label>
                        <select required
                            [ngClass]="(contact_designation.invalid && (contact_designation.dirty || contact_designation.touched)) ? 'form-control is-invalid' : (contact_designation.valid)? 'form-control is-valid':'form-control'"
                            formControlName="contact_designation" id="contact_designation">
                            <option value="">Select One</option>
                            <option value="Director">Director</option>
                            <option value="Secretary">Secretary</option>
                            <option value="Shareholder">Shareholder</option>
                        </select>
                        <div *ngIf="contact_designation.invalid && (contact_designation.dirty || contact_designation.touched)"
                            class="invalid-feedback">
                            <div *ngIf="contact_designation.errors.required">Designation is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="contact_address">Address</label>
                        <textarea required
                            [ngClass]="(contact_address.invalid && (contact_address.dirty || contact_address.touched)) ? 'form-control is-invalid' : (contact_address.valid)? 'form-control is-valid':'form-control'"
                            formControlName="contact_address" id="contact_address" placeholder="">
                    </textarea>
                        <div *ngIf="contact_address.invalid && (contact_address.dirty || contact_address.touched)"
                            class="invalid-feedback">
                            <div *ngIf="contact_address.errors.required">address is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="contact_email">E-Mail</label>
                        <input type="email" required
                            [ngClass]="(contact_email.invalid && (contact_email.dirty || contact_email.touched)) ? 'form-control is-invalid' : (contact_email.valid)? 'form-control is-valid':'form-control'"
                            formControlName="contact_email" id="contact_email" placeholder="someone@example.com">
                        <div *ngIf="contact_email.invalid && (contact_email.dirty || contact_email.touched)"
                            class="invalid-feedback">
                            <div *ngIf="contact_email.errors.required">E-Mail is required</div>
                            <div *ngIf="contact_email.errors.email">E-Mail is invalid</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="contact_phone">Phone Number</label>
                        <input type="text" required
                            [ngClass]="(contact_phone.invalid && (contact_phone.dirty || contact_phone.touched)) ? 'form-control is-invalid' : (contact_phone.valid)? 'form-control is-valid':'form-control'"
                            formControlName="contact_phone" id="contact_phone" placeholder="+X (XXX) XXX XXXX"
                            (input)="formatPhoneNumber(contactPersonDetailsForm, 'contact_phone')">
                        <div *ngIf="contact_phone.invalid && (contact_phone.dirty || contact_phone.touched)"
                            class="invalid-feedback">
                            <div *ngIf="contact_phone.errors.required">Phone number is required</div>
                            <div *ngIf="contact_phone.errors.phoneNumberInvalid">Invalid phone number format. Please use
                                +X (XXX) XXX XXXX.</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="contact_whatsapp">WhatsApp</label>
                        <input type="text" required
                            [ngClass]="(contact_whatsapp.invalid && (contact_whatsapp.dirty || contact_whatsapp.touched)) ? 'form-control is-invalid' : (contact_whatsapp.valid)? 'form-control is-valid':'form-control'"
                            formControlName="contact_whatsapp" id="contact_whatsapp" placeholder="">
                        <div *ngIf="contact_whatsapp.invalid && (contact_whatsapp.dirty || contact_whatsapp.touched)"
                            class="invalid-feedback">
                            <div *ngIf="contact_whatsapp.errors.required">WhatsApp</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="contact_nationality">Nationality</label>
                        <input type="text" required
                            [ngClass]="(contact_nationality.invalid && (contact_nationality.dirty || contact_nationality.touched)) ? 'form-control is-invalid' : (contact_nationality.valid)? 'form-control is-valid':'form-control'"
                            formControlName="contact_nationality" id="contact_nationality" placeholder="">
                        <div *ngIf="contact_nationality.invalid && (contact_nationality.dirty || contact_nationality.touched)"
                            class="invalid-feedback">
                            <div *ngIf="contact_nationality.errors.required">Nationality is required</div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <input type="hidden" formControlName="contact_ref" id="contact_ref">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                            (click)="onCancel()">Close</button>
                        <button type="button"
                            [disabled]="!contactPersonDetailsForm.valid || contactPersonDetailsForm.pending || processing"
                            (click)="onCreateContact()" class="btn btn-warning">{{contactButtonTex}}</button>
                    </div>
                </div>
            </form>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<div class="modal fade" id="modal-delete-contact">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Remove {{userName}}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p
                    [innerHTML]="'This action will remove '+userName+'. This action is not reversable, are you sure you want to continue ?'">
                </p>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-danger" (click)="deleteContact(userRef)">Delete Area</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

<div class="modal fade" id="modal-add-owner">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title"> {{ownerTitle}}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form [formGroup]="ownershipDetailsFOrm">
                <div class="modal-body">
                    <div class="form-group">
                        <label for="owner_name">Name</label>
                        <input type="text" required
                            [ngClass]="(owner_name.invalid && (owner_name.dirty || owner_name.touched)) ? 'form-control is-invalid' : (owner_name.valid)? 'form-control is-valid':'form-control'"
                            formControlName="owner_name" id="owner_name" placeholder="">
                        <div *ngIf="owner_name.invalid && (owner_name.dirty || owner_name.touched)"
                            class="invalid-feedback">
                            <div *ngIf="owner_name.errors.required">Name is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="owner_shareholding">Percentage shareholding /voting rights</label>
                        <input type="number" required
                            [ngClass]="(owner_shareholding.invalid && (owner_shareholding.dirty || owner_shareholding.touched)) ? 'form-control is-invalid' : (owner_shareholding.valid)? 'form-control is-valid':'form-control'"
                            formControlName="owner_shareholding" id="owner_shareholding" placeholder="">
                        <div *ngIf="owner_shareholding.invalid && (owner_shareholding.dirty || owner_shareholding.touched)"
                            class="invalid-feedback">
                            <div *ngIf="owner_shareholding.errors.required">
                                Percentage shareholding /voting rights is required
                            </div>   
                            <div *ngIf="owner_shareholding.errors?.exceedLimit">
                                Total percentage shareholding /voting rights is more than 100%
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="owner_politicallyExposed">Politically Exposed Persons (PEPs)</label>
                        <select required
                            [ngClass]="(owner_politicallyExposed.invalid && (owner_politicallyExposed.dirty || owner_politicallyExposed.touched)) ? 'form-control is-invalid' : (owner_politicallyExposed.valid)? 'form-control is-valid':'form-control'"
                            formControlName="owner_politicallyExposed" id="owner_politicallyExposed">
                            <option value="" selected>Select One</option>
                            <option value="0">No</option>
                            <option value="1">Yes</option>
                        </select>
                        <div *ngIf="owner_politicallyExposed.invalid && (owner_politicallyExposed.dirty || owner_politicallyExposed.touched)"
                            class="invalid-feedback">
                            <div *ngIf="owner_politicallyExposed.errors.required">Politically Exposed Persons (PEPs) is
                                required</div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <input type="hidden" formControlName="owner_ref" id="owner_ref">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                            (click)="onCancel()">Close</button>
                        <button type="button"
                            [disabled]="!ownershipDetailsFOrm.valid || ownershipDetailsFOrm.pending || processing || addShareHolder > 100"
                            (click)="onCreateOwner()" class="btn btn-warning">{{ownerButtonTex}}</button>
                    </div>
                </div>
            </form>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<div class="modal fade" id="modal-delete-owner">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Remove {{userName}}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p
                    [innerHTML]="'This action will remove '+userName+'. This action is not reversable, are you sure you want to continue ?'">
                </p>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-danger" (click)="deleteOwner(userRef)">Delete Ownership
                    Data</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

<div class="modal fade" id="modal-add-local">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title"> {{localSubTitle}}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form [formGroup]="localSubsidiaryDetailsForm">
                <div class="modal-body">
                    <div class="form-group">
                        <label for="local_name">Name</label>
                        <input type="text" required
                            [ngClass]="(local_name.invalid && (local_name.dirty || local_name.touched)) ? 'form-control is-invalid' : (local_name.valid)? 'form-control is-valid':'form-control'"
                            formControlName="local_name" id="local_name" placeholder="">
                        <div *ngIf="local_name.invalid && (local_name.dirty || local_name.touched)"
                            class="invalid-feedback">
                            <div *ngIf="local_name.errors.required">Name is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="local_address">Address</label>
                        <textarea required
                            [ngClass]="(local_address.invalid && (local_address.dirty || local_address.touched)) ? 'form-control is-invalid' : (local_address.valid)? 'form-control is-valid':'form-control'"
                            formControlName="local_address" id="local_address" placeholder="">
                    </textarea>
                        <div *ngIf="local_address.invalid && (local_address.dirty || local_address.touched)"
                            class="invalid-feedback">
                            <div *ngIf="local_address.errors.required">Address is required</div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <input type="hidden" formControlName="local_ref" id="local_ref">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                            (click)="onCancel()">Close</button>
                        <button type="button"
                            [disabled]="!localSubsidiaryDetailsForm.valid || localSubsidiaryDetailsForm.pending || processing"
                            (click)="onCreateLocal()" class="btn btn-warning">{{localSubButtonTex}}</button>
                    </div>
                </div>
            </form>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<div class="modal fade" id="modal-delete-local">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Remove {{userName}}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p
                    [innerHTML]="'This action will remove '+userName+'. This action is not reversable, are you sure you want to continue ?'">
                </p>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-danger" (click)="deleteLocal(userRef)">Delete Subsidiary</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

<div class="modal fade" id="modal-add-intl">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title"> {{intSubTitle}}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form [formGroup]="intSubsidiaryDetailsForm">
                <div class="modal-body">
                    <div class="form-group">
                        <label for="int_name">Name</label>
                        <input type="text" required
                            [ngClass]="(int_name.invalid && (int_name.dirty || int_name.touched)) ? 'form-control is-invalid' : (int_name.valid)? 'form-control is-valid':'form-control'"
                            formControlName="int_name" id="int_name" placeholder="">
                        <div *ngIf="int_name.invalid && (int_name.dirty || int_name.touched)" class="invalid-feedback">
                            <div *ngIf="owner_name.errors.required">Name is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="int_address">Address</label>
                        <textarea required
                            [ngClass]="(int_address.invalid && (int_address.dirty || int_address.touched)) ? 'form-control is-invalid' : (int_address.valid)? 'form-control is-valid':'form-control'"
                            formControlName="int_address" id="int_address" placeholder="">
                    </textarea>
                        <div *ngIf="int_address.invalid && (int_address.dirty || int_address.touched)"
                            class="invalid-feedback">
                            <div *ngIf="int_address.errors.required">Address is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="int_country">Country</label>

                        <input type="text" required
                            [ngClass]="(int_country.invalid && (int_country.dirty || int_country.touched)) ? 'form-control is-invalid' : (int_country.valid)? 'form-control is-valid':'form-control'"
                            formControlName="int_country" id="int_country" placeholder="">
                        <div *ngIf="int_country.invalid && (int_country.dirty || int_country.touched)"
                            class="invalid-feedback">
                            <div *ngIf="int_country.errors.required">Country is required</div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <input type="hidden" formControlName="int_ref" id="int_ref">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                            (click)="onCancel()">Close</button>
                        <button type="button"
                            [disabled]="!intSubsidiaryDetailsForm.valid || intSubsidiaryDetailsForm.pending || processing"
                            (click)="onCreateInt()" class="btn btn-warning">{{intSubButtonTex}}</button>
                    </div>
                </div>
            </form>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<div class="modal fade" id="modal-delete-intl">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Remove {{userName}}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p
                    [innerHTML]="'This action will remove '+userName+'. This action is not reversable, are you sure you want to continue ?'">
                </p>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-danger" (click)="deleteInt(userRef)">Delete Subsidiary</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

<div class="modal fade" id="modal-add-related">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title"> {{relatedTitle}}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form [formGroup]="relatedEntityDetailsForm">
                <div class="modal-body">
                    <div class="form-group">
                        <label for="related_name">Name</label>
                        <input type="text" required
                            [ngClass]="(related_name.invalid && (related_name.dirty || related_name.touched)) ? 'form-control is-invalid' : (related_name.valid)? 'form-control is-valid':'form-control'"
                            formControlName="related_name" id="related_name" placeholder="">
                        <div *ngIf="related_name.invalid && (related_name.dirty || related_name.touched)"
                            class="invalid-feedback">
                            <div *ngIf="related_name.errors.required">Name is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="related_nationality">Nationality</label>
                        <input type="text" required
                            [ngClass]="(related_nationality.invalid && (related_nationality.dirty || related_nationality.touched)) ? 'form-control is-invalid' : (related_nationality.valid)? 'form-control is-valid':'form-control'"
                            formControlName="related_nationality" id="related_nationality" placeholder="">
                        <div *ngIf="related_nationality.invalid && (related_nationality.dirty || related_nationality.touched)"
                            class="invalid-feedback">
                            <div *ngIf="related_nationality.errors.required">Nationality is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="related_nature">Nature of Relationship </label>
                        <input type="text" required
                            [ngClass]="(related_nature.invalid && (related_nature.dirty || related_nature.touched)) ? 'form-control is-invalid' : (related_nature.valid)? 'form-control is-valid':'form-control'"
                            formControlName="related_nature" id="related_nature" placeholder="">
                        <div *ngIf="related_nature.invalid && (related_nature.dirty || related_nature.touched)"
                            class="invalid-feedback">
                            <div *ngIf="related_nature.errors.required">Nature of relationship is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="related_director_2">Director 1 <small>optional</small></label>
                        <select
                            [ngClass]="(related_director_1.invalid && (related_director_1.dirty || related_director_1.touched)) ? 'form-control is-invalid' : (related_director_1.valid)? 'form-control is-valid':'form-control'"
                            formControlName="related_director_1" id="related_director_1">
                            <option value="0">Select One</option>
                            <option *ngFor="let directorRow of userData.directorDetails;" [value]="directorRow.ref">
                                {{directorRow.name}}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="related_director_2">Director 2 <small>optional</small></label>
                        <select required
                            [ngClass]="(related_director_2.invalid && (related_director_2.dirty || related_director_2.touched)) ? 'form-control is-invalid' : (related_director_2.valid)? 'form-control is-valid':'form-control'"
                            formControlName="related_director_2" id="related_director_2">
                            <option value="0">Select One</option>
                            <option *ngFor="let directorRow of userData.directorDetails;" [value]="directorRow.ref">
                                {{directorRow.name}}</option>
                        </select>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <input type="hidden" formControlName="related_ref" id="related_ref">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                            (click)="onCancel()">Close</button>
                        <button type="button"
                            [disabled]="!relatedEntityDetailsForm.valid || relatedEntityDetailsForm.pending || processing"
                            (click)="onCreateRelated()" class="btn btn-warning">{{relatedButtonTex}}</button>
                    </div>
                </div>
            </form>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<div class="modal fade" id="modal-delete-related">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Remove {{userName}}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p
                    [innerHTML]="'This action will remove '+userName+'. This action is not reversable, are you sure you want to continue ?'">
                </p>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-danger" (click)="deleteRelativeEntity(userRef)">Delete Related
                    Entity</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

<div class="modal fade" id="modal-add-bank">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title"> {{bankTitle}}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form [formGroup]="bankAccountForm">
                <div class="modal-body">
                    <div class="form-group">
                        <label for="bank_bankName">Bank Name</label>
                        <input type="text" required
                            [ngClass]="(bank_bankName.invalid && (bank_bankName.dirty || bank_bankName.touched)) ? 'form-control is-invalid' : (bank_bankName.valid)? 'form-control is-valid':'form-control'"
                            formControlName="bank_bankName" id="bank_bankName" placeholder="">
                        <div *ngIf="bank_bankName.invalid && (bank_bankName.dirty || bank_bankName.touched)"
                            class="invalid-feedback">
                            <div *ngIf="bank_bankName.errors.required">Bank Name is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="bank_accountNumber">Bank Account Number</label>
                        <input type="text" required
                            [ngClass]="(bank_accountNumber.invalid && (bank_accountNumber.dirty || bank_accountNumber.touched)) ? 'form-control is-invalid' : (bank_accountNumber.valid)? 'form-control is-valid':'form-control'"
                            formControlName="bank_accountNumber" id="bank_accountNumber" placeholder="">
                        <div *ngIf="bank_accountNumber.invalid && (bank_accountNumber.dirty || bank_accountNumber.touched)"
                            class="invalid-feedback">
                            <div *ngIf="bank_accountNumber.errors.required">Bank Account Number is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="bank_accountType">Bank Account Type </label>
                        <input type="text" required
                            [ngClass]="(bank_accountType.invalid && (bank_accountType.dirty || bank_accountType.touched)) ? 'form-control is-invalid' : (bank_accountType.valid)? 'form-control is-valid':'form-control'"
                            formControlName="bank_accountType" id="bank_accountType" placeholder="">
                        <div *ngIf="bank_accountType.invalid && (bank_accountType.dirty || bank_accountType.touched)"
                            class="invalid-feedback">
                            <div *ngIf="bank_accountType.errors.required">Account type is required</div>
                        </div>
                    </div>

                    <div class="modal-footer justify-content-between">
                        <input type="hidden" formControlName="bank_ref" id="bank_ref">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                            (click)="onCancel()">Close</button>
                        <button type="button"
                            [disabled]="!bankAccountForm.valid || bankAccountForm.pending || processing"
                            (click)="onCreateBank()" class="btn btn-warning">{{bankButtonTex}}</button>
                    </div>
                </div>
            </form>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<div class="modal fade" id="modal-delete-bank">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Remove {{userName}}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p
                    [innerHTML]="'This action will remove '+userName+'. This action is not reversable, are you sure you want to continue ?'">
                </p>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-danger" (click)="deleteBankAccount(userRef)">Delete Bank
                    Account</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

<div class="modal fade" id="modal-delete-document">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Remove {{userName}}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p
                    [innerHTML]="'This action will remove '+userName+'. This action is not reversable, are you sure you want to continue ?'">
                </p>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-danger" (click)="deleteFile(userRef)">Delete Uploaded File</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>